import * as ActionTypes from './adaptiveCardActionTypes';
import DisplayAppointmentFormAction from '../cardActions/DisplayAppointmentFormAction';
import DisplayReplyAllFormAction from '../cardActions/DisplayReplyAllFormAction';
import DisplayMessageFormAction from '../cardActions/DisplayMessageFormAction';
import InvokeAddinCommandAction from '../cardActions/InvokeAddinCommandAction';
import StartBotConversation from '../cardActions/StartBotConversation';
import * as Adaptive from 'adaptivecards';
import { isFeatureEnabled } from 'owa-feature-flags';

export default function registerActions() {
    Adaptive.AdaptiveCard.actionTypeRegistry.registerType(ActionTypes.INVOKE_ADDIN_COMMAND, () => {
        return new InvokeAddinCommandAction();
    });
    Adaptive.AdaptiveCard.actionTypeRegistry.registerType(
        ActionTypes.DISPLAY_REPLY_ALL_FORM,
        () => {
            return new DisplayReplyAllFormAction();
        }
    );
    Adaptive.AdaptiveCard.actionTypeRegistry.registerType(
        ActionTypes.DISPLAY_APPOINTMENT_FORM,
        () => {
            return new DisplayAppointmentFormAction();
        }
    );
    Adaptive.AdaptiveCard.actionTypeRegistry.registerType(ActionTypes.DISPLAY_MESSAGE_FORM, () => {
        return new DisplayMessageFormAction();
    });

    if (isFeatureEnabled('mc-botConversation')) {
        Adaptive.AdaptiveCard.actionTypeRegistry.registerType(
            ActionTypes.START_BOT_CONVERSATION,
            () => {
                return new StartBotConversation();
            }
        );
    }
}
